import { ReactNode } from 'react';
import { IconType } from '../icon/helpers';

const TAB_IDS = [
  'none',
  'shortcuts',
  'history',
  'user-settings',
  'agents',
  'admin-ui',
  'catalog',
  'preferences',
  'new-chat',
] as const;

export type TAB_ID = (typeof TAB_IDS)[number];

/** Returns true if `value` is a valid {@link TAB_ID}. */
export function isValidTabId(value: unknown): boolean {
  return typeof value === 'string' && (TAB_IDS as readonly string[]).includes(value);
}

export type TabAction = 'page' | 'tab' | 'link';

export type TabConfig = {
  id: TAB_ID;
  label: string;
  action: TabAction;
  icon?: IconType;
  image?: ReactNode;
  href?: string;
  disabled?: boolean;
  border?: boolean;
  primary?: boolean;
  childHrefs?: string[];
};

export const isChatPath = (path: string) => String(path).startsWith('/chat');
